(function(){
  var Q=String.fromCharCode(34);
  function q(r,s){return r.querySelector(s)}
  function qa(r,s){return [].slice.call(r.querySelectorAll(s))}

  function stockHTML(av,tracked,n,low){
    var cls='',txt='En stock · listo para despacho',bar='';
    if(!av){cls=' ak-stock--out';txt='Agotado temporalmente';}
    else if(tracked&&n>0&&n<=low){
      cls=' ak-stock--low';
      txt=n===1?'¡Última unidad disponible!':'¡Solo quedan '+n+' unidades!';
      var w=Math.max(8,Math.round(n/low*100));
      bar='<div class=ak-stockbar><span style=width:'+w+'%></span></div>';
    }
    return '<div class='+Q+'ak-stock'+cls+Q+'><span class=ak-stock__dot></span><span>'+txt+'</span></div>'+bar;
  }

  function initPdp(root){
    if(root.dataset.akInit) return;
    root.dataset.akInit='1';
    var low=parseInt(root.dataset.lowStock||'10',10);
    var atcLabel=root.dataset.atc||'Agregar al carrito';
    var slides=q(root,'.ak-slides');
    var thumbs=qa(root,'.ak-thumb');
    var dots=qa(root,'.ak-dots span');
    var count=q(root,'.ak-count');
    var total=slides?slides.children.length:0;

    function current(){return slides?Math.round(slides.scrollLeft/Math.max(1,slides.clientWidth)):0}
    function goTo(i){if(!slides)return;i=Math.max(0,Math.min(total-1,i));slides.scrollTo({left:slides.clientWidth*i,behavior:'smooth'})}
    function mark(){
      var i=current();
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i)});
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)});
      if(count)count.textContent=(i+1)+' / '+total;
      var at=thumbs[i];
      if(at){var c=at.parentNode;if(c.scrollHeight>c.clientHeight)c.scrollTo({top:Math.max(0,at.offsetTop-60),behavior:'smooth'})}
    }
    if(slides){var tm;slides.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(mark,60)},{passive:true})}
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){goTo(k)})});
    var prev=q(root,'.ak-nav--prev'),next=q(root,'.ak-nav--next');
    if(prev)prev.addEventListener('click',function(){goTo(current()-1)});
    if(next)next.addEventListener('click',function(){goTo(current()+1)});

    if(window.matchMedia&&window.matchMedia('(hover:hover) and (min-width:990px)').matches){
      qa(root,'.ak-slide[data-zoom]').forEach(function(s){
        var img=q(s,'img');if(!img)return;
        s.addEventListener('mousemove',function(e){var r=s.getBoundingClientRect();img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'});
        s.addEventListener('mouseenter',function(){s.classList.add('is-zoom')});
        s.addEventListener('mouseleave',function(){s.classList.remove('is-zoom');img.style.transformOrigin='center'});
      });
    }

    /* Cantidad */
    var qty=q(root,'.ak-qty input');
    qa(root,'.ak-qty button').forEach(function(b){
      b.addEventListener('click',function(){
        if(!qty)return;
        var v=(parseInt(qty.value,10)||1)+parseInt(b.dataset.step,10);
        var mx=parseInt(qty.getAttribute('max')||'0',10);
        if(mx>0)v=Math.min(mx,v);
        qty.value=Math.max(1,v);
        qty.dispatchEvent(new Event('change',{bubbles:true}));
        qty.dispatchEvent(new Event('input',{bubbles:true}));
      });
    });

    /* Variantes */
    var vsel=q(root,'.ak-vsel');
    var idInput=q(root,'.product-variant-id');
    function applyVariant(o){
      var d=o.dataset,av=d.available==='1',has=parseInt(d.off||'0',10)>0;
      if(idInput){idInput.value=o.value;idInput.dispatchEvent(new Event('change',{bubbles:true}))}
      qa(root,'[data-ak-price]').forEach(function(e){e.textContent=d.price});
      qa(root,'[data-ak-compare]').forEach(function(e){e.textContent=d.compare;e.hidden=!has});
      qa(root,'[data-ak-off]').forEach(function(e){e.textContent=d.off+'% OFF';e.hidden=!has});
      qa(root,'[data-ak-badge]').forEach(function(e){e.textContent='-'+d.off+'%';e.hidden=!has});
      qa(root,'[data-ak-save]').forEach(function(e){e.textContent='Ahorras '+d.save;e.hidden=!has});
      var sku=q(root,'[data-ak-sku]');if(sku){sku.hidden=!d.sku;var sp=q(sku,'span');if(sp)sp.textContent=d.sku}
      var st=q(root,'[data-ak-stock]');if(st)st.innerHTML=stockHTML(av,d.tracked==='1',parseInt(d.qty||'0',10),low);
      var btn=q(root,'.product-form__submit');
      if(btn){btn.disabled=!av;var t=q(btn,'span');if(t)t.textContent=av?atcLabel:'Agotado'}
      if(qty){if(d.tracked==='1'&&d.deny==='1'&&parseInt(d.qty,10)>0){qty.setAttribute('max',d.qty)}else{qty.removeAttribute('max')}}
      try{var u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState(null,'',u.toString())}catch(e){}
      if(d.media&&slides){var sl=[].slice.call(slides.children);var ix=sl.findIndex(function(s){return s.dataset.mediaId===d.media});if(ix>-1)goTo(ix)}
    }
    function pickVariant(){
      if(!vsel)return;
      var vals=qa(root,'.ak-opt').map(function(fs){
        var c=q(fs,'input:checked');
        var l=q(fs,'legend span');if(c&&l)l.textContent=c.value;
        return c?c.value:'';
      });
      var title=vals.join(' / ');
      var opt=[].slice.call(vsel.options).find(function(o){return o.dataset.title===title});
      if(opt){applyVariant(opt)}else{
        var btn=q(root,'.product-form__submit');
        if(btn){btn.disabled=true;var t=q(btn,'span');if(t)t.textContent='No disponible'}
      }
    }
    qa(root,'.ak-opt input').forEach(function(i){i.addEventListener('change',pickVariant)});

    /* Fecha de entrega y cuenta regresiva (hora Colombia) */
    var dl=q(root,'[data-ak-delivery]');
    if(dl){
      var minD=parseInt(root.dataset.dmin||'2',10),maxD=parseInt(root.dataset.dmax||'5',10),cut=parseInt(root.dataset.cutoff||'14',10),skip=root.dataset.skip||'sun';
      if(maxD<minD)maxD=minD;
      var dias=['dom','lun','mar','mié','jue','vie','sáb'],meses=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      var bogotaNow=function(){
        try{
          var f=new Intl.DateTimeFormat('en-US',{timeZone:'America/Bogota',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});
          var p={};f.formatToParts(new Date()).forEach(function(x){p[x.type]=x.value});
          var h=parseInt(p.hour,10);if(h===24)h=0;
          return new Date(+p.year,+p.month-1,+p.day,h,+p.minute,+p.second);
        }catch(e){return new Date()}
      };
      var isOff=function(d){var w=d.getDay();return (skip==='sun'&&w===0)||(skip==='weekend'&&(w===0||w===6))};
      var addBiz=function(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);if(!isOff(x))n--}return x};
      var fmt=function(d){return dias[d.getDay()]+' '+d.getDate()+' '+meses[d.getMonth()]};
      var arrive=q(dl,'[data-ak-arrive]'),tw=q(root,'[data-ak-timerwrap]'),tmr=q(root,'[data-ak-timer]'),alt=q(root,'[data-ak-timeralt]');
      var tick=function(){
        var now=bogotaNow();
        var today=new Date(now.getFullYear(),now.getMonth(),now.getDate());
        var shipsToday=!isOff(today)&&now.getHours()<cut;
        var ship=shipsToday?today:addBiz(today,1);
        while(isOff(ship))ship=addBiz(ship,1);
        var a=addBiz(ship,minD),b=addBiz(ship,maxD);
        if(arrive)arrive.innerHTML=(minD===maxD)?'Llega el <b>'+fmt(a)+'</b>':'Llega entre el <b>'+fmt(a)+'</b> y el <b>'+fmt(b)+'</b>';
        if(tw&&tmr){
          if(shipsToday){
            var end=new Date(today);end.setHours(cut,0,0,0);
            var s=Math.max(0,Math.floor((end-now)/1000)),h=Math.floor(s/3600),m=Math.floor(s%3600/60),sec=s%60;
            tmr.textContent=h+'h '+String(m).padStart(2,'0')+'m '+String(sec).padStart(2,'0')+'s';
            tw.hidden=false;if(alt)alt.hidden=true;
          }else{
            tw.hidden=true;if(alt){alt.hidden=false;alt.innerHTML='Pide hoy y lo despachamos el <b>'+fmt(ship)+'</b>'}
          }
        }
      };
      tick();setInterval(tick,1000);
    }

    /* WhatsApp mayorista con origen de trafico */
    qa(root,'[data-ak-wa]').forEach(function(a){
      a.addEventListener('click',function(){
        var src='orgánico';try{src=new URLSearchParams(location.search).get('utm_source')||src}catch(e){}
        var msg='['+src.toUpperCase()+'] '+(a.dataset.msg||'')+' '+location.origin+location.pathname;
        a.href='https://api.whatsapp.com/send?phone='+a.dataset.phone+'&text='+encodeURIComponent(msg);
      });
    });

    /* Boton contra entrega (Releasit): se marca y ordena con CSS, sin mover el boton */
    var buy=q(root,'.ak-buy');
    function codBtns(){
      if(!buy)return [];
      var l=qa(buy,'._rsi-buy-now-button,.rsi-buy-now-button,#rsi_buy_now_button,[class*=_rsi-buy-now],[class*=rsi_animation]');
      if(!l.length)l=qa(buy,'button:not(.product-form__submit):not([data-step]):not(.shopify-payment-button__button):not(.shopify-payment-button__more-options)');
      return l;
    }
    function tagCod(){
      var l=codBtns();if(!l.length)return false;
      l.forEach(function(c){
        if(c.classList.contains('ak-cod'))return;
        c.classList.add('ak-cod');
        var f=c.closest('form'),n=c;
        while(n.parentElement&&n.parentElement!==f&&n.parentElement!==buy){n=n.parentElement}
        if(n.classList.contains('product-form__buttons')){c.style.order='-1'}else if(n!==c||n.parentElement===f){n.classList.add('ak-cod-wrap')}
      });
      root.classList.add('ak-has-cod');root.classList.remove('ak-no-cod');
      return true;
    }
    var tries=0;
    (function waitCod(){if(tagCod())return;if(++tries<24){setTimeout(waitCod,250)}else{root.classList.add('ak-no-cod')}})();
    if(buy&&'MutationObserver' in window){new MutationObserver(function(){tagCod()}).observe(buy,{childList:true,subtree:true})}

    /* Boton fijo en celular: aparece cuando los botones de compra ya pasaron (arriba de la pantalla) */
    var sticky=q(root,'.ak-sticky');
    var stickyOn=null;
    function liftBubble(on){
      var cb=document.getElementById('chat-bubble');
      if(!cb)return;
      cb.style.transition='bottom .3s ease';
      if(on){cb.style.setProperty('bottom',(Math.ceil(sticky.getBoundingClientRect().height)+16)+'px','important')}else{cb.style.removeProperty('bottom')}
    }
    function checkSticky(){
      if(!sticky||!buy)return;
      var mobile=window.innerWidth<990;
      var on=mobile&&buy.getBoundingClientRect().bottom<0;
      if(on===stickyOn)return;
      stickyOn=on;
      sticky.classList.toggle('is-on',on);
      sticky.inert=!on;
      sticky.setAttribute('aria-hidden',on?'false':'true');
      liftBubble(on);
    }
    var raf=0;
    window.addEventListener('scroll',function(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;checkSticky()})},{passive:true});
    window.addEventListener('resize',checkSticky);
    setTimeout(checkSticky,300);setTimeout(checkSticky,2000);
    var sb=q(root,'.ak-sticky__btn');
    if(sb)sb.addEventListener('click',function(){
      var c=q(root,'.ak-cod');
      if(c){c.click();return}
      if(buy)buy.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }

  function boot(){qa(document,'.ak-pdp').forEach(initPdp)}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector('.ak-pdp');if(r){delete r.dataset.akInit;initPdp(r)}});
})();
